import classNames from 'classnames';
import React, { ElementType } from 'react';
import { twMerge } from 'tailwind-merge';

interface IBreadcrumbs {
  label: string;
  path?: string;
}

interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumbs[];
  jsx: ElementType;
}

export function Breadcrumbs({ breadcrumbs, jsx: Jsx }: IBreadcrumbsProps) {
  return (
    <>
      <nav aria-label="Breadcrumb">
        <ol
          className={twMerge(
            'flex h-14 list-none items-stretch gap-2 rounded bg-white px-4 shadow-md',
            'shadow-slate-200',
          )}
        >
          {breadcrumbs.map((item, index) => (
            <li
              className={classNames({
                'flex flex-1 items-center gap-2':
                  index === breadcrumbs.length - 1,
                'flex items-center gap-2': index === breadcrumbs.length - 2,
                'hidden items-center gap-2 md:flex':
                  index < breadcrumbs.length - 2,
              })}
              key={item.label}
            >
              <Jsx
                className={classNames(
                  'flex max-w-[20ch] items-center gap-1 truncate whitespace-nowrap font-semibold',
                  {
                    'text-slate-400 pointer-events-none':
                      index === breadcrumbs.length - 1,
                    'text-secondary-two transition-colors  hover:text-primaryFixxer-one':
                      index < breadcrumbs.length - 1,
                  },
                )}
                href={item.path || ''}
              >
                {item.label}
              </Jsx>
              {index !== breadcrumbs.length - 1 && (
                <svg
                  aria-hidden="true"
                  aria-labelledby={`aria-title-0${index} aria-description-0${index}`}
                  className={twMerge(
                    'h-4 w-4 flex-none',
                    'stroke-slate-700 transition-transform md:rotate-180',
                  )}
                  fill="none"
                  role="graphics-symbol"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title id={`title-0${index}`}>Arrow</title>
                  <desc id={`description-0${index}`}>
                    Arrow icon that points to the next page in big screen
                    resolution sizes and previous page in small screen
                    resolution sizes.
                  </desc>
                  <path
                    d="M15 19l-7-7 7-7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
